module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "tp"
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("How to Sew:"), _c('br'), _vm._v("Sew Basics")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_c('b', [_vm._v("This in-depth guide has been crafted by a team of experienced"), _c('br'), _vm._v("professionals, including award-winning cafters Susan Briscoe, Lynne"), _c('br'), _vm._v("Edwards and Dorothy Wood. Their expertise gives you the ideal"), _c('br'), _vm._v("introduction to the basics of sewing wonderful and creative designs.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Use your new found skills on great projects and more specific"), _c('br'), _vm._v("techniques by checking out the additional "), _c('i', [_vm._v("How to Sew")]), _vm._v(" range:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "1",
      "cellspacing": "1",
      "frame": "box",
      "rules": "all",
      "summary": "",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "align": "center"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Sashiko")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Decorative Sewing")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Bead Embroidery")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Patchwork")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Machine Sewing")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Felt Fabric")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Applique")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Hand Sewing")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('i', [_c('b', [_vm._v("Embellishments")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('b', [_vm._v("See the end of this book for more information on these   "), _c('br'), _vm._v("great titles, or to buy visit your favourite online retailer.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "logo",
      "src": "images/logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8893660a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_9780715338865_epub_tp.vue
// module id = 57
// module chunks = 0